import { FileItem } from '../../files/models/file-item.model';

export class FileProgressResponse {
  constructor(
    public status: string,
    public message: number,
    public fileItem?: FileItem
  ) {}
}
